import Lottie from '../Components/Lottie';
import loader from '../Assets/json/globe.json';
import { useContext } from 'react';
import { DonationContext } from '../Context/Donation';
import getNumberText from '../utils/getNumberText';
import numeral from 'numeral';

const HomeShowcase = () => {

  const { donationState: {
    summary
  } = {} } = useContext(DonationContext);


    return (
      <div className="py-10 font-poppins md:py-20 lg:flex relative lg:py-0 lg:h-612 items-center lg:overflow-hidden">
        <div className="layout__wrapper  ">
          <div className="lg:w-2/3 xl:w-1/2">
            <h6 className="font-bold text-2xl text-chestNut md:text-4xl md:leading-53 font-tiempos lg:text-50">
              Tracking Resources Committed to COVID-19 in Africa
            </h6>
            <p className="mt-3 text-xs text-metal leading-5 md:text-base md:leading-8 lg:text-xs lg:leading-6 lg:w-3/4 xl:w-full">
              The COVID-19 Transparency and Accountability Project (CTAP) is
              committed to tracking all resources from public sector, private,
              multiltaleral and bilateral donors committed to COVID-19 pandemic.
            </p>

            <div className="pt-10 md:pt-12 md:flex md:justify-between md:flex-wrap">
              <div className="mb-7 last:mb-0 w-full md:w-1/2 lg:w-auto pr-4">
                <h6 className="text-28px font-bold text-chestNut leading-37 md:text-2rem capitalize">
                  {(() => {
                    const result = getNumberText(summary?.resourcesCommitted);
                    return (
                      <>
                        ${result?.value}
                        <span className="text-base uppercase ml-1">
                          {result?.unit}
                        </span>
                      </>
                    );
                  })()}
                </h6>
                <span className="leading-8 text-base text-metal md:text-lg">
                  Resources Committed
                </span>
              </div>
              <div className="mb-7 last:mb-0  w-full md:w-1/2 lg:w-auto">
                <h6 className="text-28px font-bold text-chestNut leading-37 md:text-2rem capitalize">
                  {(() => {
                    const result = getNumberText(summary?.materialDonations);
                    return (
                      <>
                        ${result?.value}
                        <span className="text-base uppercase ml-1">
                          {result?.unit}
                        </span>
                      </>
                    );
                  })()}
                </h6>
                <span className="leading-8 text-base text-metal md:text-lg">
                  In-Kind Donation
                </span>
              </div>
              <div className="mb-7 last:mb-0  w-full md:w-1/2 lg:w-auto">
                <h6 className="text-28px font-bold text-chestNut leading-37 md:text-2rem capitalize">
                  {!!summary?.dataSet && numeral(summary?.dataSet).format('0,0')}
                </h6>
                <span className="leading-8 text-base text-metal md:text-lg">
                  Datasets
                </span>
              </div>
              <div className="mb-7 last:mb-0  w-full md:w-1/2 lg:w-auto">
                <h6 className="text-28px font-bold text-chestNut leading-37 md:text-2rem capitalize">
                  {!!summary?.vaccination && numeral(summary?.vaccination).format('0,0')}
                </h6>
                <span className="leading-8 text-base text-metal md:text-lg">
                Fully vaccinated
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute homeShowcase__animation">
          <Lottie loop={false} loader={loader} />
        </div>
      </div>
    );
}
 
export default HomeShowcase;